import { Box, Flexbox, Icon, Typography } from '@hiiretail/synergy-ui';
import { ErrorContainer } from './ErrorBox.styles';
import { ErrorBoxComponent } from './ErrorBox.types';
import { useMemo } from 'react';

export const ErrorBox: ErrorBoxComponent = ({ error }) => {
  
  const errorMessage = useMemo(() => {
    if (Array.isArray(error?.response?.data?.message)) {
      return (error.response.data.message as Array<string | { error: string }>).map((msg) => (
        <Typography key={typeof msg === 'string' ? msg : (msg as { error: string }).error} color={() => 'white'}>
          {typeof msg === 'object' && msg !== null && 'error' in msg ? (msg as { error: string }).error : msg}
        </Typography>
      ));
    }

    if(error?.response?.data.message === 'User can not have more than 10 groups'){
      return 'User cannot be a member of more than 10 Groups';
    }
    return error?.response?.data.message;
  }, [error?.response?.data?.message]);

  return (
    <>
      {error && (
        <Box mb={4}>
          <ErrorContainer
            container
            gutter={2}
            direction="column"
            alignItems="center"
            data-testid="error-box"
          >
            <Flexbox item>
              <Icon.WarningTriangle size="lg" color={() => 'white'} />
            </Flexbox>
            <Flexbox item container alignItems="flex-start">
              <Typography color={() => 'white'}>
                An error occurred: <br />
                <Typography weight="bold" color={() => 'white'}>
                  {errorMessage}
                </Typography>
              </Typography>
            </Flexbox>
          </ErrorContainer>
        </Box>
      )}
    </>
  );
};
